"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
function omitProp(props, propToOmit) {
  const { [propToOmit]: _, ...filteredProps } = props;
  return filteredProps;
}
exports.omitProp = omitProp;
